import {
	GeneralDocument,
	generalDocumentQuery,
	type ResolvedDoc,
} from '#app/components/general-document.tsx'
import { safeFetch } from '#app/utils/sanity.server.ts'
import { type Route } from './+types/swiss.ts'

export async function loader() {
	// In Sanity Studio, set the Name field to "swiss" for this document
	const doc = await safeFetch<ResolvedDoc | null>(
		`*[_type == "generalDocument" && name == "swiss"][0] ${generalDocumentQuery}`,
	)
	return { doc }
}

export default function SwissExplained({ loaderData }: Route.ComponentProps) {
	return <GeneralDocument doc={loaderData.doc} />
}
